const importRegex = /(^|\s)(import)\s*\(/g;
export function convertDynamicImport(code) {
    return code.replace(importRegex, ' $csbImport(');
}
